import {
    CREATE_SHORT_EXCESS,
    DELETE_SHORT_EXCESS,
    GET_SHORT_EXCESS,
    GET_SHORT_EXCESS_PAGE,
    SHORT_EXCESS_REQUEST_SUCCESS,
    SHORT_EXCESS_REQUEST,
    SHORT_EXCESS_REQUEST_FAILURE,
    UPDATE_SHORT_EXCESS
  } from "../types/short-excess-types";
  
  const initialState = {
    shortExcess: [],
    shortExcessPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const shortExcessReducer = (state = initialState, action) => {
    switch (action.type) {
      case SHORT_EXCESS_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_SHORT_EXCESS: {
        return {
          ...state,
          shortExcess: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_SHORT_EXCESS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          shortExcessPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_SHORT_EXCESS:
        return {
          ...state,
          shortExcess: [action.payload, ...state.shortExcess],
          loading: false,
          error: null
        };
      case UPDATE_SHORT_EXCESS:
        const shortExcessData = state.shortExcess.slice(0);
        console.log('before>>', shortExcessData);
        const uIndex = shortExcessData.findIndex((data) => data.id === action.payload.id);
        console.log('uIndex>>', uIndex);
        shortExcessData.splice(uIndex, 1, { ...action.payload.data });
        console.log('after>>', shortExcessData.splice(uIndex, 1, { ...action.payload.data }));
        
        return {
          ...state,
          shortExcess: [ ...shortExcessData ],
          loading: false,
          error: null
        };
      case DELETE_SHORT_EXCESS:
        const shortExcess = state.shortExcess?.slice(0);
        const index = shortExcess.findIndex((data) => data.id === action.id);
        if (index > -1) {
          shortExcess.splice(index, 1);
        }
        return {
          ...state,
          shortExcess: [...shortExcess],
          loading: false,
          error: null
        }
      case SHORT_EXCESS_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case SHORT_EXCESS_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default shortExcessReducer;
  